import axios from '@/utils/request';

export const getTotalAlarm = ( groupNo ) => axios.get("/blade-wems/devicealarm/total/count?groupNo=" + groupNo);

export const getAlarmLevel = ( groupNo ) => axios.get("/blade-wems/devicealarm/level/group/count?groupNo=" + groupNo);

export const getAlarmGroup = ( groupNo ) => axios.get("/blade-wems/devicealarm/system/group/count?groupNo=" + groupNo);

export const getAlarmType = ( groupNo ) => axios.get("/blade-wems/devicealarm/deviceType/group/count?groupNo=" + groupNo);

export const getCurrentAlarmList = (params) => axios.get("/blade-wems/devicealarm/page", {params});

export const confimAlarm = (id) => axios.post("/blade-wems/devicealarm/confirm?id="+id);

export const clearAlarm = (id) => axios.post("/blade-wems/devicealarm/clear?id="+id);

export const getHisTotalAlarm = ( groupNo ) => axios.get("/blade-wems/devicealarmhis/total/count?groupNo=" + groupNo);

export const getHisAlarmLevel = ( groupNo ) => axios.get("/blade-wems/devicealarmhis/level/group/count?groupNo=" + groupNo);

export const getHisAlarmGroup = ( groupNo ) => axios.get("/blade-wems/devicealarmhis/system/group/count?groupNo=" + groupNo);

export const getHisAlarmType = ( groupNo ) => axios.get("/blade-wems/devicealarmhis/deviceType/group/count?groupNo=" + groupNo);

export const getHisAlarmList = (params) => axios.get("/blade-wems/devicealarmhis/page", {params});

export const getContainerAlarmList = (params) => axios.get("/blade-wems/devicealarm/page",{ params });

export const getContainerHisAlarmList = (params) => axios.get("/blade-wems/devicealarmhis/page", { params });

export const getContainerAlarmChart = (params) => axios.get("/blade-wems/bmsgroup/alarm/overview/info", { params });

export const getContainerAlarmHisChart = (params) => axios.get("/blade-wems/bmsgroup/historyalarm/overview/info", { params });

export const getClusterList = () => axios.get("/blade-wems/cluster/alarm/template/list");

export const getClusterAlarmList = (clusterId) => axios.get("/blade-wems/cluster/alarm/list?clusterId=" + clusterId);

export const getContainerAlarmInfo = (containerNo) => axios.get("/blade-wems/container/alarm/info?containerNo=" + containerNo);

export const  getContainerAlarmInfoPage = (params) => axios.get("/blade-wems/devicealarm/page", { params });

export const getRackList = () => axios.get("/blade-wems/rack/alarm/template/list");

export const getRackAlarmList = (rackId) => axios.get("/blade-wems/rack/alarm/list?rackId=" + rackId);

export const getdevicealarmupdatetime = (groupNo) => axios.get("/blade-wems/devicealarm/updatetime?groupNo=" + groupNo);

export const getdevicealarmhisupdatetime = (groupNo) => axios.get("/blade-wems/devicealarmhis/updatetime?groupNo=" + groupNo);

export const getGlobalTips = () => axios.get('/blade-wems/devicealarm/global/tip');

// 告警模板查询
export const  getAlarmtemplatePage = (params) => axios.get("/blade-wems/alarmtemplate/page", { params });
//新增或修改保存告警模板
export const alarmtemplateUpdate =(params) => axios.post("/blade-wems/alarmtemplate/submit", params);
// 删除告警模板
export const deleteAlarmtemplate =(ids) => axios.post("/blade-wems/alarmtemplate/delete?ids="+ids);
// 根据设备类型查询其告警转发服务
export const  getAlarmtemplateIdentifierList = (params) => axios.get("/blade-wems/alarmtemplate/identifier/list", { params });

